var React = require('react');

function ContactFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.884 30c.39 0 4.167-6.585 4.417-6.647.25-.063 8.56 3.662 8.972 2.959C25.685 25.609 30.731.295 30 0 29.269-.295.813 15.724 0 16.487c-.41.385 1.572 1.387 3.642 2.347 2.035.944 4.153 1.853 4.475 1.715.432-.186 5.924-4.773 16.475-13.762C16.19 16.118 11.954 20.856 11.884 21c-.105.216-.39 9 0 9z","fill":"currentColor","fillRule":"evenodd"}));
}

ContactFooter.defaultProps = {"width":"31px","height":"30px","viewBox":"0 0 31 30"};

module.exports = ContactFooter;

ContactFooter.default = ContactFooter;
